import { ElementType } from 'react';
import { Box, BoxProps, Button, ButtonProps } from '@mui/material';

type NavbarButtonOwnProps = {
  sx?: BoxProps['sx'];
  active: boolean;
};

type NavbarButtonProps<RootComponent extends ElementType> = ButtonProps<
  RootComponent,
  NavbarButtonOwnProps
>;

const NavbarButton = <RootComponent extends ElementType>({
  sx,
  active,
  ...buttonProps
}: NavbarButtonProps<RootComponent>) => (
  <Box
    display="flex"
    alignSelf="stretch"
    alignItems="center"
    // The pt value mirrors the bottom border so that the content is centered relative to the
    // border-box rather than the content-box (which is what flex does.)
    pt="5px"
    borderBottom={5}
    borderColor={{ xs: 'transparent', lg: active ? 'common.white' : 'midnight.main' }}
    sx={{ ...sx, transition: { lg: 'border-color 250ms' } }}
  >
    <Button {...buttonProps} color="midnight" variant="contained" />
  </Box>
);

export { NavbarButton, NavbarButtonProps };
